/**
 * @generated SignedSource<<d004970516d192c7450fc0c653c9b3f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type diligenceReportPageGenerateMutation$variables = Record<PropertyKey, never>;
export type diligenceReportPageGenerateMutation$data = {
  readonly exportCreate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly export: {
      readonly id: string;
      readonly status: string;
    } | null | undefined;
  } | null | undefined;
};
export type diligenceReportPageGenerateMutation = {
  response: diligenceReportPageGenerateMutation$data;
  variables: diligenceReportPageGenerateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "kind",
    "value": "DILIGENCE_KPIS"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Export",
  "kind": "LinkedField",
  "name": "export",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "diligenceReportPageGenerateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ExportCreateMutationPayload",
        "kind": "LinkedField",
        "name": "exportCreate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "exportCreate(kind:\"DILIGENCE_KPIS\")"
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "diligenceReportPageGenerateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "ExportCreateMutationPayload",
        "kind": "LinkedField",
        "name": "exportCreate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "exportCreate(kind:\"DILIGENCE_KPIS\")"
      }
    ]
  },
  "params": {
    "cacheID": "812008caf9e4ff9ddb24d9f35f16f828",
    "id": null,
    "metadata": {},
    "name": "diligenceReportPageGenerateMutation",
    "operationKind": "mutation",
    "text": "mutation diligenceReportPageGenerateMutation {\n  exportCreate(kind: \"DILIGENCE_KPIS\") {\n    export {\n      id\n      status\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fd5fb3eaabde283e5977cca79980cec0";

export default node;
